import React from "react";

import ContentCore from "../../../../core/workingContent";

const FinishLate = () => {
  return (
    <ContentCore />
  )
}

export default FinishLate